var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"uc-pill-root",attrs:{"data-external":"uc-pill"}},[(_vm.icon)?_c('UCIcon',{staticClass:"icon",attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }